import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from 'const';
import { RegisteredTerms } from 'containers/RegisteredTerms/RegisteredTerms';
import { TermsOfUseLanding } from 'containers/TermsOfUseLanding';
import { REGISTERED_TERMS_TRANSLATIONS } from 'const/translations/TermsOfUse';
import { REGISTERED_USER_TERMS_REDIRECTS } from '../const/RoutesRedirects';
import { LogoutHandler } from './LogoutHandler';

const {
  REGISTERED_SUBSCRIPTION_TERMS,
  REGISTERED_SUBSCRIPTION_TERMS_TITLE,
  REGISTERED_USAGE_TERMS,
  REGISTERED_USAGE_TERMS_TITLE,
} = REGISTERED_TERMS_TRANSLATIONS;

export const RegisteredUserTermsRoutes = () => (
  <Routes>
    <Route index element={<RegisteredTerms />} />
    <Route
      path={ROUTES.TERMS_OF_USE_LANDING}
      element={
        <TermsOfUseLanding
          hasBreadcrumb={false}
          termsText={REGISTERED_USAGE_TERMS}
          title={REGISTERED_USAGE_TERMS_TITLE}
          hasLogoOnPage
        />
      }
    />
    <Route
      path={ROUTES.TERMS_OF_SUBSCRIPTION}
      element={
        <TermsOfUseLanding
          hasBreadcrumb={false}
          termsText={REGISTERED_SUBSCRIPTION_TERMS}
          title={REGISTERED_SUBSCRIPTION_TERMS_TITLE}
          hasLogoOnPage
        />
      }
    />
    <Route path={ROUTES.LOGOUT} element={<LogoutHandler />} />
    {REGISTERED_USER_TERMS_REDIRECTS.map(({ to, from }) => (
      <Route
        key={`${from}_${to}`}
        path={from}
        element={<Navigate to={to} replace />}
      />
    ))}
    <Route path="*" element={<Navigate to={ROUTES.ROOT} replace />} />
  </Routes>
);
